// Checks the stored login against the server. Pass an HTTP client WITHOUT the
// app's global error interceptor (it redirects to /login on 401).
export async function verifySession(http) {
  try {
    const res = await http.get('/api/user/self');
    const body = res && res.data;
    if (body && body.success && body.data) return { state: 'valid', user: body.data };
    return { state: 'invalid' };
  } catch (e) {
    if (e && e.response && (e.response.status === 401 || e.response.status === 403)) {
      return { state: 'invalid' };
    }
    return { state: 'unknown' }; // network hiccup: keep the local session
  }
}
